import EnLang from './entries/en-US';
import trLang from './entries/tr_TR';
//import enRtlLang from './entries/en-US-rtl';
const AppLocale = {
    en: EnLang,
    tr: trLang,
  //  enrtl: enRtlLang,
  };
  
  export default AppLocale;
